import React from 'react';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import type {
  ClickCarouselLinkPayload,
  NavigateCarouselPayload,
  PillBarCarouselProps,
} from '@noths/polaris-client-ribbons-design-system';
import { PillBarCarousel } from '@noths/polaris-client-ribbons-design-system';

export enum LinkCarouselTrackingCategory {
  RelatedCategory = 'Related Category',
  ChildCategory = 'Child Category',
}

export interface LinkCarouselProps extends PillBarCarouselProps {
  trackingCategory: LinkCarouselTrackingCategory;
}

export const LinkCarousel = ({ id, title, links, trackingCategory }: LinkCarouselProps) => {
  return (
    <PillBarCarousel
      id={id}
      title={title}
      links={links}
      onLinkClick={(
        evt: React.MouseEvent<HTMLAnchorElement>,
        { link }: ClickCarouselLinkPayload,
      ) => {
        sendGALinkClickEvent(evt, {
          event: 'custom_event',
          event_category: trackingCategory,
          event_action: 'Link Click',
          event_label: link.title!,
        });
      }}
      onNavigateCarousel={({ navigation }: NavigateCarouselPayload) => {
        sendGAEvent({
          event: 'custom_event',
          event_category: trackingCategory,
          event_action: navigation.type,
          event_label: navigation.direction,
        });
      }}
      onVisible={() => {
        sendGAEvent({
          event: 'custom_event',
          event_category: trackingCategory,
          event_action: 'Impression',
          event_label: 'not set',
        });
      }}
    />
  );
};
